import { render, staticRenderFns } from "./NotificationCardForActivityResult.vue?vue&type=template&id=0550d506&scoped=true&"
import script from "./NotificationCardForActivityResult.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForActivityResult.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForActivityResult.vue?vue&type=style&index=0&id=0550d506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550d506",
  null
  
)

export default component.exports